const d3 = require('d3');

/**
 * 2 次元座標を扱うための utility
 */
module.exports = {
    /**
     * 2 つの座標が - y 軸に対してなす角を返す。
     *
     * source から見て target が SVG coordinate で
     * + x 方向(画面右側)に存在する場合に 0 が
     * - y 方向(上)に存在する場合に 90 が返る
     *
     * source, target 共に以下の形式
     * {
         *   x: 51
         *   y: 10
         * }
     *
     * @returns {number}
     */
    angle: function(source, target) {
        return Math.atan2(
                - (target.y - source.y),
                (target.x - source.x)
            ) / Math.PI * 180;
    },

    /**
     * 2 つの座標の間の内分点を返す。
     *
     * ratio が 1 ならば target の座標が
     * 0 ならば source の座標が返ってくる。
     *
     * @param {number} [ratio=0.5] - 0 から 1 までの float
     */
    interpolate: function(source, target, ratio) {
        ratio = ratio ? ratio : 0.5;
        return {
            x: d3.interpolate(source.x, target.x)(ratio),
            y: d3.interpolate(source.y, target.y)(ratio)
        };
    },

    /**
     * 以下の形式で与えられた座標群の x, y それぞれの min, max を返す。
     *
     * {
         *   min: {
         *     x: 0,
         *     y: 0
         *   },
         *   max: {
         *     x: 100,
         *     y: 100
         *   }
         * }
     */
    range: function(vectors) {
        return {
            min: {
                x: _.chain(vectors).pluck('x').min().value(),
                y: _.chain(vectors).pluck('y').min().value()
            },
            max: {
                x: _.chain(vectors).pluck('x').max().value(),
                y: _.chain(vectors).pluck('y').max().value()
            }
        }
    }
}



// WEBPACK FOOTER //
// ./common/vector-util.js